// TODO GD Turn this into pure CSS, extract pendant styles... to the pendant
import machineLogicStyles from '@vse-legacy/machinelogic_style';
import { setEnvironment } from '@vse/environment';

export function applyMachineLogicStyles (): void {
  // Required because machineLogicStyles checks the environment
  // The page doesn't matter, but without it, the function will log an error in the console
  setEnvironment('pendant', 'configuration');
  machineLogicStyles.defineCssRules();
}
